var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevel1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.067,
  height: 17.49
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "level1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.067v17.49H0z",
  "data-name": "Rectangle 18364"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M2.563 2.92 0 4.337l.34 1.486 1.954-1.056h.035v9.8h1.883V2.92Z",
  "data-name": "Path 647946"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 644055"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#level1_svg__a)",
  "data-name": "Group 644054"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.067 2H9.651a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647947"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.067 5.872H9.651a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647948"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.067 9.745H9.651a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647949"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M20.067 13.618H9.651a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.067 17.49H9.651a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647951"
})))));
export { SvgLevel1 as ReactComponent };
export default __webpack_public_path__ + "438bf0da2770d879502b39b7d24ada66.svg";